// extracted by mini-css-extract-plugin
export default {"items":"styles_items__eRvbo"};